!function(){"use strict";!function(e,t){var r=e.amplitude||{_q:[],_iq:{}};if(r.invoked)e.console&&console.error&&console.error("Amplitude snippet has been loaded.");else{var n=function(e,t){e.prototype[t]=function(){return this._q.push({name:t,args:Array.prototype.slice.call(arguments,0)}),this}},s=function(e,t,r){return function(n){e._q.push({name:t,args:Array.prototype.slice.call(r,0),resolve:n})}},o=function(e,t,r){e[t]=function(){if(r)return{promise:new Promise(s(e,t,Array.prototype.slice.call(arguments)))};!function(e,t,r){e._q.push({name:t,args:Array.prototype.slice.call(r,0)})}(e,t,Array.prototype.slice.call(arguments))}},i=function(e){for(var t=0;t<y.length;t++)o(e,y[t],!1);for(var r=0;r<g.length;r++)o(e,g[r],!0)};r.invoked=!0;var c=t.createElement("script");c.type="text/javascript",c.integrity="sha384-IC8jJYsWV4kAr3RAMNY16hyrQI1DbzQpJ/rItHJ61tvBSQlzogCfklP3XQFp2L92",c.crossOrigin="anonymous",c.async=!0,c.src="https://cdn.amplitude.com/libs/analytics-browser-2.23.5-min.js.gz",c.onload=function(){e.amplitude.runQueuedFunctions||console.log("[Amplitude] Error: could not load SDK")};var a=t.getElementsByTagName("script")[0];a.parentNode.insertBefore(c,a);for(var u=function(){return this._q=[],this},p=["add","append","clearAll","prepend","set","setOnce","unset","preInsert","postInsert","remove","getUserProperties"],l=0;l<p.length;l++)n(u,p[l]);r.Identify=u;for(var d=function(){return this._q=[],this},f=["getEventProperties","setProductId","setQuantity","setPrice","setRevenue","setRevenueType","setReceipt","setReceiptSig","setCurrency","setEventProperties"],v=0;v<f.length;v++)n(d,f[v]);r.Revenue=d;var y=["getDeviceId","setDeviceId","getSessionId","setSessionId","getUserId","setUserId","setOptOut","setTransport","reset","extendSession"],g=["init","add","remove","track","logEvent","identify","groupIdentify","setGroup","revenue","flush"];i(r),r.createInstance=function(e){return r._iq[e]={_q:[]},i(r._iq[e]),r._iq[e]},e.amplitude=r}}(window,document)}();

// amplitude.add({
//     name: 'logger',
//     type: 'enrichment',
//     setup: async () => undefined,
//     execute: async (event) => {
//         console.log(event?.event_properties?.['[Amplitude] Element Text'] ?? event.event_type, event);
//         return event;
//     },
// });

const options = {
    transport: navigator.sendBeacon ? 'beacon' : 'fetch',
    autocapture: {
        attribution: true,
        pageViews: true,
        sessions: true,
        formInteractions: true,
        fileDownloads: true,
        elementInteractions: true,
        networkTracking: {
            ignoreAmplitudeRequests: true,
        },
    },
    trackingOptions: {
        ipAddress: true,
        platform: true,
    },
};

// stg
// amplitude.init("b6cea49920972ecc449ae5ff8759518c", options);
//prod
amplitude.init("9be589eb5f45bcc35179425708f8448a", options).promise.then(() => {
    try {
        let ampDeviceId = amplitude.getDeviceId();
        let ampSessionId = amplitude.getSessionId();

        if (!ampDeviceId) {
            ampDeviceId = crypto.randomUUID();
            amplitude.setDeviceId(ampDeviceId);
        }


        if (!ampSessionId) {
            ampSessionId = Date.now()
            amplitude.setSessionId(ampSessionId);
        }
    } catch (e) {
        console.error('Failed to init amplitude session', e)
    }
}).catch(console.error);

const REFS_COOKIE = '__mooz_refs';
const REFS_COOKIE_MAX_AGE = 2592000; // 30 days

const refKeys = [
    'referral',
    'moozref',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
];

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
};

const setCookie = (name, value) => {
    const encoded = encodeURIComponent(value);
    document.cookie = `${name}=${encoded}; domain=.mooz.pro; path=/; max-age=${REFS_COOKIE_MAX_AGE}; SameSite=Lax; Secure`;
};

(function () {
    const initUrl = new URL(location.href);
    const queryParams = Object.fromEntries(
        Object.entries(Object.fromEntries(initUrl.searchParams)).filter(([key, value]) => refKeys.includes(key) && !!value)
    );

    let savedRefs = {};

    try {
        const cookieRefs = getCookie(REFS_COOKIE);
        if (cookieRefs) {
            savedRefs = JSON.parse(cookieRefs);
        }
    } catch (e) {
        console.error('Failed to retrieve saved refs', e);
    }

    if (Object.values(queryParams).length > 0) {
        const newRefs = {};

        refKeys.forEach((key) => {
            const param = queryParams[key];
            if (param && !newRefs[key]) {
                newRefs[key] = param;
            }
        });

        savedRefs = newRefs;
    }

    setCookie(REFS_COOKIE, JSON.stringify(savedRefs));
})()

const isRelativeLink = (candidate) => candidate.startsWith('./') || candidate.startsWith('/');

const getUrlObject = (href) => {
    if (isRelativeLink(href)) {
        return new URL(`relative://relative/${href.split('/').slice(1).join('/')}`)
    } else {
        return new URL(href);
    }
}

const appendAmplitudeParams = (link) => {
    try {
        const url = getUrlObject(link.href);

        if (location.hostname !== url.hostname) {
            const ampDeviceId = amplitude.getDeviceId();

            if (ampDeviceId) {
                url.searchParams.set('ampDeviceId', ampDeviceId);
            }

            const ampSessionId = amplitude.getSessionId();

            if (ampSessionId) {
                url.searchParams.set('ampSessionId', ampSessionId);
            }

            if (url.protocol === 'relative') {
                link.href = `${url.pathname}${url.search}${url.hash}`
            } else {
                link.href = url.href;
            }
        }
    } catch (e) {
        console.error('Failed to append amplitude params', e);
    }
}

const getLink = (e) => e.target.closest('a');

const beforeLinkClickHandler = (e) => {
    const link = getLink(e);

    if (link) {
        // Исключаем ссылки социального шаринга из обработки
        // Они уже содержат правильный URL статьи в параметрах
        if (link.closest('.article-social-share')) {
            return;
        }
        
        appendAmplitudeParams(link);
    }
}

document.addEventListener('pointerdown', beforeLinkClickHandler)
document.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
        beforeLinkClickHandler(e);
    }
});